import React from 'react';

/**
 * Toggle switch — matches Yapp's "pause anonymous messages" control.
 * Controlled: pass `checked` and `onChange(next)`.
 */
export function Toggle({
  checked = false,
  onChange,
  disabled = false,
  tone = 'brand',
  label,
  style = {},
  ...rest
}) {
  const onColors = {
    brand: 'var(--brand-500)',
    warning: 'rgba(255,152,0,0.85)',
    success: 'var(--success-500)',
  };
  const w = 44, h = 24, knob = 18;

  const sw = (
    <button
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => !disabled && onChange && onChange(!checked)}
      style={{
        position: 'relative',
        width: w,
        height: h,
        flexShrink: 0,
        padding: 0,
        border: 'none',
        borderRadius: 'var(--radius-pill)',
        background: checked ? (onColors[tone] || onColors.brand) : 'var(--neutral-300)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'background var(--duration-normal) var(--ease-standard)',
        ...style,
      }}
      {...rest}
    >
      <span style={{
        position: 'absolute',
        top: (h - knob) / 2,
        left: checked ? w - knob - 3 : 3,
        width: knob,
        height: knob,
        borderRadius: '50%',
        background: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
        transition: 'left var(--duration-normal) var(--ease-standard)',
      }} />
    </button>
  );

  if (!label) return sw;
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '0.6rem', cursor: disabled ? 'not-allowed' : 'pointer' }}>
      {sw}
      <span style={{ fontSize: 'var(--text-sm)', color: 'var(--text-body)' }}>{label}</span>
    </label>
  );
}
